const objectUrlToFile = async (
  objectUrl: string,
  filename: string,
  mimeType = 'image/jpeg',
): Promise<File> => {
  const response = await fetch(objectUrl)
  const blob = await response.blob()

  return new File([blob], filename, { type: mimeType })
}

export default objectUrlToFile
